import React, {useEffect, useRef} from 'react';

// Meant to be used e.g. for closing modals when clicking outside of them, using a components local state updater function.
const useOutsideClickStateUpdater = (stateUpdateFn: React.Dispatch<React.SetStateAction<boolean>>): { outsideClickRef: React.MutableRefObject<any> } => {
  const ref: React.MutableRefObject<any> = useRef(null);

  const handleClickOutside = (event: Event): void => {
    if (ref.current && !ref.current.contains(event.target)) {
      stateUpdateFn(false);
    }
  };

  useEffect((): () => void => {
    document.addEventListener('click', handleClickOutside, true);
    return (): void => document.removeEventListener('click', handleClickOutside, true);
  }, []);

  return {outsideClickRef: ref};
};

export default useOutsideClickStateUpdater;